function initProductSwiper() {
  document.querySelectorAll('.productSwiper').forEach((slider) => {

    if (slider.swiper) return;

    new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 600,
      loop: false,
      navigation: {
        nextEl: ".custom-home-banner-next",
        prevEl: ".custom-home-banner-prev",
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initProductSwiper);
document.addEventListener('shopify:section:load', initProductSwiper);